import { Node } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { YouTubeVideoPre } from "#app/routes/admin+/blog+/posts+/editor/extensions/youtube-video/components/chooser.tsx";

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    youtubePre: {
      setYoutubePre: () => ReturnType;
      removeYoutubePre: () => ReturnType;
    };
  }
}

export const YoutubeVideoChooser = Node.create({
  name: "youtubePre",

  group: "block",

  inline: false,

  selectable: true,

  isolating: true,

  defining: true,

  draggable: true,

  parseHTML() {
    return [
      {
        tag: `div[data-type="${this.name}"]`,
      },
    ];
  },

  renderHTML() {
    return ["div", { "data-type": this.name }];
  },

  addCommands() {
    return {
      setYoutubePre:
        () =>
        ({ commands }) =>
          commands.insertContent(`<div data-type="${this.name}"></div>`),
      removeYoutubePre:
        () =>
        ({ state, dispatch }) => {
          const { tr } = state;
          let modified = false;

          state.doc.descendants((node, pos) => {
            const isUnusedNode = node.type.name === "youtubePre";

            if (isUnusedNode) {
              tr.delete(pos, pos + node.nodeSize);
              modified = true;
            }
          });

          if (modified && dispatch) {
            dispatch(tr);
          }

          return modified;
        },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(YouTubeVideoPre);
  },
});
